import { C_ACTION } from '../constans';

let order_id;
let new_state;

export const collections = (state = [], action) => {
  switch (action.type) {
    case C_ACTION.ADD_COLLECTIONS: {
      return [...action.data];
    }
    case C_ACTION.DELETE_COLLECTION: {
      order_id = state.findIndex(item => item.orderId === action.id);
      new_state = [...state];
      new_state.splice(order_id, 1);
      return new_state;
    }
    case C_ACTION.CHANGE_COLLECTIONS: {
      order_id = state.findIndex(item => item.orderId === action.id);
      new_state = [...state];
      new_state.splice(order_id, 1, { ...action.item });
      return new_state;
    }

    default:
      return state;
  }
};
